import type { ResponseData } from '@vrplatform/data';

export type TaxPayableSummary =
  ResponseData<'get:/teams/opening-balances/tax-payable'>;
export type AdvancedDepositsSummary =
  ResponseData<'get:/teams/opening-balances/advanced-deposits'>;

export const normalizeTaxPayableSummary = (
  summary: TaxPayableSummary | null | undefined
): TaxPayableSummary => ({
  amount: summary?.amount ?? 0,
  currency: summary?.currency ?? '',
  updatedAt: summary?.updatedAt ?? null,
  transactionId: summary?.transactionId ?? null,
});

export const normalizeAdvancedDepositsSummary = (
  summary: AdvancedDepositsSummary | null | undefined
): AdvancedDepositsSummary => ({
  amount: summary?.amount ?? 0,
  currency: summary?.currency ?? '',
  updatedAt: summary?.updatedAt ?? null,
  transactionId: summary?.transactionId ?? null,
  account: summary?.account ?? null,
  reservations: summary?.reservations ?? [],
});
